export const handleShowSearchFilterOption = (
    input: string,
    option: { label: unknown; value: string | number | boolean } | undefined
): boolean => {
    const labelText = typeof option?.label === "string" ? option.label : String(option?.label ?? "");
    const valueText = String(option?.value ?? "");

    return (
        labelText.toLowerCase().includes(input.toLowerCase()) || valueText.toLowerCase().includes(input.toLowerCase())
    );
};
